export { A as ApiExplorerIndexPage, D as DefaultApiExplorerPage } from './esm/ApiExplorerPage-ce544a95.esm.js';
export { A as ApiDefinitionCard } from './esm/ApiDefinitionCard-504c2432.esm.js';
import { r as rootRoute, a as apiDocsConfigRef, b as registerComponentRouteRef, d as defaultDefinitionWidgets } from './esm/ApiDefinitionWidget-798ee85f.esm.js';
export { A as AsyncApiDefinitionWidget, G as GraphQlDefinitionWidget, O as OpenApiDefinitionWidget, T as TrpcApiDefinitionWidget, a as apiDocsConfigRef, d as defaultDefinitionWidgets } from './esm/ApiDefinitionWidget-798ee85f.esm.js';
export { A as ApiTypeTitle, P as PlainApiDefinitionWidget } from './esm/ApiTypeTitle-cc79a2f3.esm.js';
export { A as ApiDefinitionDialog, C as ConsumedApisCard, H as HasApisCard, P as ProvidedApisCard } from './esm/ProvidedApisCard-e92fbd29.esm.js';
export { C as ConsumingComponentsCard, P as ProvidingComponentsCard } from './esm/ProvidingComponentsCard-5b679445.esm.js';
import '@backstage/plugin-catalog-react';
import '@material-ui/lab';
import 'react';
import '@backstage/core-components';
import { createPlugin, createApiFactory, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import '@material-ui/core/Typography';
import 'react-router-dom';
import '@backstage/plugin-catalog';
import '@backstage/plugin-permission-react';
import '@backstage/plugin-catalog-common/alpha';
import '@material-ui/core/styles';
import '@backstage/catalog-model';
import '@material-ui/core';
import '@material-ui/icons/Extension';

const apiDocsPlugin = createPlugin({
  id: "api-docs",
  routes: {
    root: rootRoute
  },
  apis: [
    createApiFactory({
      api: apiDocsConfigRef,
      deps: {},
      factory: () => {
        const definitionWidgets = defaultDefinitionWidgets();
        return {
          getApiDefinitionWidget: (apiEntity) => {
            return definitionWidgets.find((d) => d.type === apiEntity.spec.type);
          }
        };
      }
    })
  ],
  externalRoutes: {
    registerApi: registerComponentRouteRef
  }
});
const ApiExplorerPage = apiDocsPlugin.provide(
  createRoutableExtension({
    name: "ApiExplorerPage",
    component: () => import('./esm/index-435dfc01.esm.js').then((m) => m.ApiExplorerIndexPage),
    mountPoint: rootRoute
  })
);
const EntityApiDefinitionCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityApiDefinitionCard",
    component: {
      lazy: () => import('./esm/index-6f21bd2e.esm.js').then((m) => m.ApiDefinitionCard)
    }
  })
);
const EntityConsumedApisCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityConsumedApisCard",
    component: {
      lazy: () => import('./esm/index-5f0727eb.esm.js').then((m) => m.ConsumedApisCard)
    }
  })
);
const EntityConsumingComponentsCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityConsumingComponentsCard",
    component: {
      lazy: () => import('./esm/index-c969ed3d.esm.js').then(
        (m) => m.ConsumingComponentsCard
      )
    }
  })
);
const EntityProvidedApisCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityProvidedApisCard",
    component: {
      lazy: () => import('./esm/index-5f0727eb.esm.js').then((m) => m.ProvidedApisCard)
    }
  })
);
const EntityProvidingComponentsCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityProvidingComponentsCard",
    component: {
      lazy: () => import('./esm/index-c969ed3d.esm.js').then(
        (m) => m.ProvidingComponentsCard
      )
    }
  })
);
const EntityHasApisCard = apiDocsPlugin.provide(
  createComponentExtension({
    name: "EntityHasApisCard",
    component: {
      lazy: () => import('./esm/index-5f0727eb.esm.js').then((m) => m.HasApisCard)
    }
  })
);

export { ApiExplorerPage, EntityApiDefinitionCard, EntityConsumedApisCard, EntityConsumingComponentsCard, EntityHasApisCard, EntityProvidedApisCard, EntityProvidingComponentsCard, apiDocsPlugin, apiDocsPlugin as plugin };
//# sourceMappingURL=index.esm.js.map
